const env_mixtmt = require('./mixtmt')
const env_cctv = require('./cctv')

const VUE_APP_MODE = process.env.VUE_APP_MODE
const customizePro = process.env.VUE_APP_CUSTOMIZE
const customizeProNameStr = process.env.VUE_APP_CUSTOMIZEPRONAMEARR
const modeArr = process.env.VUE_APP_MODEARR

function computedEnvApi() {
  let index = 0
  const apiArr = [env_mixtmt, env_cctv]
  customizeProNameArr = customizeProNameStr.split(',')
  for (let i = 0; i < customizeProNameArr.length; i++) {
    const proItem = customizeProNameArr[i]
    if (proItem === customizePro) {
      index = i
    }
  }
  let curApiObj = null
  if (modeArr.includes(VUE_APP_MODE)) {
    curApiObj = apiArr[index][VUE_APP_MODE]
  } else {
    // 默认  mixtmt dev
    curApiObj = apiArr[index][modeArr[0]]
  }
  return curApiObj
}

function getEnvStatus() {
  return VUE_APP_MODE
}

module.exports = {
  computedEnvApi,
  getEnvStatus
}
